import { HealthStatus } from '../../contracts/viewTypes';

export const HEALTH_STATUS_CONFIG: Record<HealthStatus, { label: string; color: string }> = {
  [HealthStatus.SAFE]: { label: 'Safe', color: 'success.main' },
  [HealthStatus.MONITORING]: { label: 'Monitoring', color: 'warning.main' },
  [HealthStatus.CRITICAL]: { label: 'Critical', color: 'error.main' },
};

const UNKNOWN_STATUS_CONFIG = { label: 'Unknown', color: 'text.disabled' };

export const getHealthStatusConfig = (status: HealthStatus) =>
  Object.hasOwn(HEALTH_STATUS_CONFIG, status) ? HEALTH_STATUS_CONFIG[status] : UNKNOWN_STATUS_CONFIG;
